import { AxiosWrapper } from "auth/axios.wrapper";

export interface PrCreateRequest {
  results: {
    PrNumber: string;
    DocType: string;
    TaskNumber: string;
    Test_Run: string;
    HeaderToItem: {
      results: PrCreateItem[];
    };
  };
}

export interface PrCreateItem {
  PrItemNo: string;
  PurGroup: string;
  Material: string;
  ShortText: string;
  Plant: string;
  Quantity: string;
  Unit: string;
  DocType: string;
  ItemCat: string;
  AccAssignmentCat: string;
  DelivDate: string;
  ReqDate: string;
  PriceUnit: string;
  Currency: string;
  GlAcc: string;
  CostCenter: string;
  ValPrice: string;
  Vendor: string;
  ExtReqNo: string;
}

export default class SapService {
  static createPurchaseRequest = async (
    body: PrCreateRequest,
    sapSystemAlias?: string
  ): Promise<any> => {
    const httpClient = new AxiosWrapper();
    const params = new URLSearchParams();
    
    if (sapSystemAlias) {
      params.append("sapSystemAlias", sapSystemAlias);
    }
    
    const url = `/api/sapdata/PrCreate?action=1${params.toString() ? `&${params.toString()}` : ""}`;
    
    const response = await httpClient.post(url, body);
    return response.data;
  };
}
